<template>
  <div class="detail">
    <a-page-header :title="isAdd ? '新建资讯' : '修改资讯'" @back="goback" />
    <a-form layout="horizontal" :form="form" ref="form" class="po-inner">
      <!-- 资讯标题 -->
      <a-form-item label="标题" :spellcheck="false" :labelCol="{ lg: { span: 2 } }" :wrapperCol="{ lg: { span: 9 } }">
        <a-input type="text" placeholder="请输入" style="width:260px" v-decorator="[
          'title',
          {
            rules: [{ required: true, message: '请输入资讯标题' }],
            validateTrigger: 'change',
          },
        ]" />
      </a-form-item>
      <!-- 资讯封面 -->
      <a-form-item class="upload-item xinghao" label="上传照片" :labelCol="{ lg: { span: 2 } }"
        :wrapperCol="{ lg: { span: 18 } }">
        <a-input type="text" hidden v-decorator="[
          'test',
          {
            rules: [{ required: true }],
            validateTrigger: 'change',
          },
        ]" />
        <c-upload ossType="avatar" ref="coverUrl" :isSingle="true" accept="image/*" @uploadSuccess="uploadSuccess"
          :sourceFileList="sourceFileList"></c-upload>

        <p style="color:rgba(0, 0, 0, 0.65); font-size:14px;line-height:100%">
          图片大小1280*1110
          <span v-if="disabled" style="color:#f00">* 图片上传尺寸有误，请重新上传</span>
        </p>
      </a-form-item>
      <!-- 生效时间 -->
      <a-form-item label="生效时间" :labelCol="{ lg: { span: 2 } }" :wrapperCol="{ lg: { span: 18 } }">
        <div style="display:flex; width:520px;transform: translateY(4px);">
          <a-date-picker style="width:calc(50% - 12px)" format="YYYY-MM-DD HH:mm:ss"
            :defaultValue="validBeginTime ? moment(validBeginTime, 'YYYY-MM-DD HH:mm:ss') : ''"
            :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="请选择时间" @change="onChange"
            @ok="ok1" />


          <span style="display:block; width:24px; text-align: center; height:32px; line-height:32px">-</span>
          <a-date-picker style="width:calc(50% - 12px)" format="YYYY-MM-DD HH:mm:ss"
            :defaultValue="validEndTime ? moment(validEndTime, 'YYYY-MM-DD HH:mm:ss') : ''"
            :showTime="{ defaultValue: moment('00:00:00', 'HH:mm:ss') }" placeholder="请选择时间" @change="onChange2"
            @ok="ok2" />

        </div>
        <p v-if="tips" style="color:#ff0000">* 开始时间不能大于结束时间</p>
      </a-form-item>
      <a-form-item label="资讯内容" :labelCol="{ lg: { span: 2 } }" :wrapperCol="{ lg: { span: 18 } }">
        <c-richtext style="width:800px; height:500px" :editorContent.sync="editorContent"></c-richtext>
      </a-form-item>
      <div style="padding-left:8.3%">
        <a-button type="primary" v-if="isAdd" :disabled="disabled" @click="handleSubmit">保存</a-button>
        <a-button type="primary" v-else :disabled="disabled" @click="handleSubmit">确认修改</a-button>
      </div>
    </a-form>
  </div>
</template>
<script>
import news from '../../api/notice'
import CUpload from '../../components/CUpload'
import CRichtext from '../../components/CRichtext'
import moment from 'moment'
export default {
  name: 'add',
  data() {
    return {
      disabled: false,
      form: this.$form.createForm(this),
      isAdd: true, //是否是新增person
      newsId: -1,
      updateData: {},
      confirmLoading: false,
      coverUrl: '',
      sourceFileList: [],
      editorContent: '', //编辑器内容
      show: false,
      validBeginTime: '',
      validEndTime: '',
      VerifyPicture: false,
      tips: false,
    }
  },
  components: {
    CUpload,
    CRichtext,
  },
  created() {
    this.init(this.$route.query)
    setTimeout(() => {
      this.form.setFieldsValue({ test: 'Invalid code' })
    }, 100)
  },
  methods: {
    // 比较时间大小
    bijiao(time01, time02) {
      console.log('开始时间：', time01)
      console.log('结束时间', time02)
      var now = new Date(time01)
      var end = new Date(time02)
      if (now - end > 0) {
        this.tips = true
      } else {
        this.tips = false
      }
      console.log(this.tips)
    },
    moment,
    ok1(value) {
      if (this.validEndTime != undefined || this.validEndTime != '') {
        this.bijiao(this.validBeginTime, this.validEndTime)
      }
    },
    ok2(value) {
      if (this.validBeginTime != undefined || this.validBeginTime != '') {
        this.bijiao(this.validBeginTime, this.validEndTime)
      }
    },
    onChange(value, dateString) {
      this.validBeginTime = dateString
      if (this.validEndTime != undefined || this.validEndTime != '') {
        this.bijiao(dateString, this.validEndTime)
      }
    },
    onChange2(value, dateString) {
      this.validEndTime = dateString
      this.bijiao(this.validBeginTime, dateString)
    },
    //   返回上一级
    goback() {
      this.$router.go(-1)
    },
    //头像上传成功之后回调
    uploadSuccess(url) {
      console.log(url)

      if (this.show) {
        let img = new Image()
        img.src = url
        const vm = this
        img.onload = function () {
          if (img.width == 1280 && img.height == 1110) {
            vm.coverUrl = url
            vm.VerifyPicture = true
            console.log('图片路径001', vm.coverUrl)
            vm.disabled = false
          } else {
            vm.$message.warning('仅支持 1280*1110 大小的图片')
            vm.disabled = true
          }
        }
      } else {
        this.coverUrl = url
        console.log('图片路径002', this.coverUrl)
      }
    },

    //初始化，显示
    init(params) {
      console.log('params', params)

      //初始化form表单数据
      if (JSON.stringify(params) != '{}') {
        this.isAdd = false
        this.updateData = params
        console.log(params)

        let formData = {}
        formData.title = params.title
        this.editorContent = params.content
        this.sourceFileList = [params.coverUrl]
        this.coverUrl = params.coverUrl

        if (params.validBeginTime != undefined || params.validEndTime != undefined) {
          this.validBeginTime = params.validBeginTime
          this.validEndTime = params.validEndTime
        }
        this.newsId = params.id
        setTimeout(() => {
          this.form.setFieldsValue(formData)
        }, 100)
      } else {
        this.validBeginTime = ''
        this.validEndTime = ''
        this.sourceFileList = []
        this.form.resetFields()
        this.editorContent = ''
      }
    },

    //隐藏
    handleCancel() {
      this.$emit('closeForm')
    },

    //新增保存
    handleSubmit(e) {
      console.log(this.disabled, 'disabled')
      this.form.test = '无效内容'
      this.form.validateFields((err, value) => {
        // 校验通过
        if (!err) {
          console.log('this.coverUrl', this.coverUrl)
          value.content = this.editorContent
          value.coverUrl = this.coverUrl
          value.type = '3'
          if (this.validEndTime == undefined) {
            this.validEndTime = ''
          }
          if (this.validBeginTime == undefined) {
            this.validBeginTime = ''
          }
          value.validEndTime = this.validEndTime
          value.validBeginTime = this.validBeginTime
          this.bijiao(value.validBeginTime, value.validEndTime)
          if (!this.tips) {
            if (this.isAdd) {
              this.addNews(value)
            } else {
              this.updateNews(value)
            }
          }
        }
      })

    },

    //新增保存接口
    addNews(value) {
      let img = new Image()
      img.src = value.coverUrl
      const vm = this
      img.onload = function () {
        if (img.width == 1280 && img.height == 1110) {
          news.createNews(value).then(res => {
            vm.$message.success('新增成功')
            vm.goback()
            vm.handleCancel()
            vm.$emit('refreshNews')
          })
        } else {
          vm.$message.warning('仅支持 1280*1110 大小的图片')
        }
      }
    },
    // 修改保存接口
    updateNews(value) {
      let img = new Image()
      img.src = value.coverUrl
      const vm = this
      img.onload = function () {
        if (img.width == 1280 && img.height == 1110) {
          news.updateNews(vm.newsId, value).then(res => {
            vm.$message.success('修改成功')
            vm.goback()
            Object.assign(vm.updateData, value)
            vm.handleCancel()
          })
        } else {
          vm.$message.warning('仅支持 1280*1110 大小的图片')
        }
      }
    },
  },
}
</script>
<style scoped>
.ant-page-header {
  padding: 0;
}

.po-inner {
  padding-top: 20px;
}

/* .ant-btn-primary {
  background: #11d690 !important;
  border-color: #11d690 !important;
} */
.xinghao.ant-form-item label {
  display: block !important;
  background: #000 !important;
}
</style>
